/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type FaceSide = "FRONT" | "SIDE" | "TOP" | "%future added value";
export type KnownObject = "BIN_BMW_M1" | "BIN_BMW_M2" | "BIN_BMW_M3" | "BIN_BMW_M4" | "BIN_BMW_M5" | "BIN_BMW_M6" | "BIN_BMW_M7" | "BIN_BMW_M8" | "BIN_BMW_P1" | "BIN_BMW_P2" | "BIN_IBC" | "BLOCK_SKID_BMW" | "BLOCK_SKID_DIVERT" | "BLOCK_SKID_DIVERT_SMALL" | "BOX_BABY_OIL_WITHOUT_ALOE" | "BOX_BABY_OIL_WITH_ALOE" | "BOX_CONTACT_LENSES" | "BOX_JETPUFFED" | "BOX_LOWES_LARGE" | "BOX_LOWES_SMALL" | "BOX_M2" | "BOX_NEWARK" | "BOX_PLAIN_WIDE" | "BOX_PROXY_10_12_7" | "BOX_PROXY_12_12_8" | "BOX_PROXY_13_13_8" | "BOX_UNSPECIFIED" | "BOX_ZALANDO" | "ITEM_AIRBAG" | "ITEM_FORKLIFT" | "ITEM_HUMAN" | "ITEM_LOAD_RESTRAINT" | "ITEM_STABILIZING_CARDBOARD" | "ITEM_STRIPED_AIRBAG" | "ITEM_UNKNOWN" | "ITEM_WEATHER_GUARD_LEFT" | "ITEM_WEATHER_GUARD_RIGHT" | "ITEM_WEATHER_GUARD_TOP" | "PALLET_BD_SURFACE" | "PALLET_CP1" | "PALLET_CUSTOM_BD" | "PALLET_EUR" | "PALLET_GMA" | "PALLET_GMA_BLOCK" | "PALLET_HALF" | "PALLET_UNSPECIFIED" | "STRINGER_CANADIAN" | "UNKNOWN" | "%future added value";
export type LabelingPriority = "HIGH" | "LOW" | "UNSPECIFIED" | "%future added value";
export type PalletSurface = "FLOOR" | "FORKLIFT" | "PALLET_EMPTY" | "PALLET_LOADED" | "RACK" | "TRUCK" | "UNKNOWN" | "%future added value";
export type RunSource = "BD_FIELD_TRIP" | "BD_TRIAL_RUN" | "FOX_FIELD_TRIP" | "FOX_OFFICE" | "UNKNOWN" | "%future added value";
export type ListSensorStreamsRefetchQueryVariables = {
    runNameQuery?: string | null;
    runDateStartQuery?: unknown | null;
    runDateEndQuery?: unknown | null;
    labelerQuery?: string | null;
    allowExport?: boolean | null;
    knownObjects?: ReadonlyArray<KnownObject> | null;
    objectSide?: ReadonlyArray<FaceSide> | null;
    objectSurface?: ReadonlyArray<PalletSurface> | null;
    countAllSensorStreams: number;
    after?: string | null;
};
export type ListSensorStreamsRefetchQueryResponse = {
    readonly viewer: {
        readonly username: string | null;
        readonly isAnonymous: boolean | null;
        readonly isSupervisor: boolean | null;
        readonly allSensorStreams: {
            readonly pageInfo: {
                readonly hasNextPage: boolean;
            };
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly id: string;
                    readonly numFrames: number;
                    readonly labelingPriority: LabelingPriority;
                    readonly createTime: unknown;
                    readonly updateTime: unknown;
                    readonly run: {
                        readonly id: string;
                        readonly runName: string;
                        readonly source: RunSource;
                        readonly createTime: unknown;
                        readonly updateTime: unknown;
                        readonly knownObjects: ReadonlyArray<KnownObject>;
                    };
                    readonly " $fragmentRefs": FragmentRefs<"SensorStreamListItem_sensorStream">;
                } | null;
            } | null>;
        } | null;
    } | null;
};
export type ListSensorStreamsRefetchQuery = {
    readonly response: ListSensorStreamsRefetchQueryResponse;
    readonly variables: ListSensorStreamsRefetchQueryVariables;
};



/*
query ListSensorStreamsRefetchQuery(
  $runNameQuery: String
  $runDateStartQuery: DateTime
  $runDateEndQuery: DateTime
  $labelerQuery: String
  $allowExport: Boolean
  $knownObjects: [KnownObject!]
  $objectSide: [FaceSide!]
  $objectSurface: [PalletSurface!]
  $countAllSensorStreams: Int!
  $after: String
) {
  viewer {
    username
    isAnonymous
    isSupervisor
    allSensorStreams: sensorStreams(first: $countAllSensorStreams, after: $after, runNameQuery: $runNameQuery, runDateStartQuery: $runDateStartQuery, runDateEndQuery: $runDateEndQuery, labelerQuery: $labelerQuery, knownObjects: $knownObjects, objectSide: $objectSide, objectSurface: $objectSurface, allowExport: $allowExport) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          ...SensorStreamListItem_sensorStream
          numFrames
          labelingPriority
          createTime
          updateTime
          run {
            id
            runName
            source
            createTime
            updateTime
            knownObjects
          }
          __typename
        }
        cursor
      }
    }
    id
  }
}

fragment LabelingIssueListItem_issue on LabelingIssue {
  id
  description
  category
  status
  reporter {
    username
    id
  }
  labeler {
    username
    id
  }
  pallets {
    number
    id
  }
  boxes {
    number
    id
  }
  sensorStream {
    sensorName
    run {
      runName
      id
    }
    id
  }
  frame {
    indexInSensorStream
    id
  }
}

fragment SensorStreamListItem_sensorStream on SensorStream {
  id
  labelingDirections
  lightingConditions
  sensorName
  numFrames
  frameNumbers
  labelingPriority
  allowExport
  issues {
    ...LabelingIssueListItem_issue
    status
    id
  }
  run {
    runName
    source
    createTime
    updateTime
    id
  }
  labelSummary {
    labeledFrameCount
    viewerLabeledFrameCount
    labeledPocketCount
    labeledItemCount
    labeledPalletsAll {
      id
      objectType
      surfaceType
      author {
        id
        username
        shortName
      }
      frame {
        indexInSensorStream
        id
      }
    }
    labeledItemsAll {
      id
      objectType
      author {
        id
        username
        shortName
      }
      frame {
        indexInSensorStream
        id
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "runNameQuery",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "runDateStartQuery",
    "type": "DateTime",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "runDateEndQuery",
    "type": "DateTime",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "labelerQuery",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "allowExport",
    "type": "Boolean",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "knownObjects",
    "type": "[KnownObject!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "objectSide",
    "type": "[FaceSide!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "objectSurface",
    "type": "[PalletSurface!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "countAllSensorStreams",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "after",
    "type": "String",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "username",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isAnonymous",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isSupervisor",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "numFrames",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "labelingPriority",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "createTime",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "updateTime",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "runName",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "source",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "knownObjects",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v15 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "allowExport",
    "variableName": "allowExport"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "countAllSensorStreams"
  },
  {
    "kind": "Variable",
    "name": "knownObjects",
    "variableName": "knownObjects"
  },
  {
    "kind": "Variable",
    "name": "labelerQuery",
    "variableName": "labelerQuery"
  },
  {
    "kind": "Variable",
    "name": "objectSide",
    "variableName": "objectSide"
  },
  {
    "kind": "Variable",
    "name": "objectSurface",
    "variableName": "objectSurface"
  },
  {
    "kind": "Variable",
    "name": "runDateEndQuery",
    "variableName": "runDateEndQuery"
  },
  {
    "kind": "Variable",
    "name": "runDateStartQuery",
    "variableName": "runDateStartQuery"
  },
  {
    "kind": "Variable",
    "name": "runNameQuery",
    "variableName": "runNameQuery"
  }
],
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "sensorName",
  "args": null,
  "storageKey": null
},
v17 = [
  (v1/*: any*/),
  (v5/*: any*/)
],
v18 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "number",
    "args": null,
    "storageKey": null
  },
  (v5/*: any*/)
],
v19 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "frame",
  "storageKey": null,
  "args": null,
  "concreteType": "Frame",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "indexInSensorStream",
      "args": null,
      "storageKey": null
    },
    (v5/*: any*/)
  ]
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "objectType",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "author",
  "storageKey": null,
  "args": null,
  "concreteType": "LabelerUser",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v1/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "shortName",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ListSensorStreamsRefetchQuery",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "LinkedField",
            "alias": "allSensorStreams",
            "name": "__ListSensorStreams_allSensorStreams_connection",
            "storageKey": null,
            "args": null,
            "concreteType": "SensorStreamConnection",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "SensorStreamEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SensorStream",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "run",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Run",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v12/*: any*/)
                        ]
                      },
                      (v13/*: any*/),
                      {
                        "kind": "FragmentSpread",
                        "name": "SensorStreamListItem_sensorStream",
                        "args": null
                      }
                    ]
                  },
                  (v14/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ListSensorStreamsRefetchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "LinkedField",
            "alias": "allSensorStreams",
            "name": "sensorStreams",
            "storageKey": null,
            "args": (v15/*: any*/),
            "concreteType": "SensorStreamConnection",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "SensorStreamEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SensorStream",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "labelingDirections",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "lightingConditions",
                        "args": null,
                        "storageKey": null
                      },
                      (v16/*: any*/),
                      (v6/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "frameNumbers",
                        "args": null,
                        "storageKey": null
                      },
                      (v7/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "allowExport",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "issues",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "LabelingIssue",
                        "plural": true,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "description",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "category",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "status",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "reporter",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "LabelerUser",
                            "plural": false,
                            "selections": (v17/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "labeler",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "LabelerUser",
                            "plural": false,
                            "selections": (v17/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "pallets",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "LabeledPallet",
                            "plural": true,
                            "selections": (v18/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "boxes",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "LabeledBox",
                            "plural": true,
                            "selections": (v18/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "sensorStream",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "SensorStream",
                            "plural": false,
                            "selections": [
                              (v16/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "run",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Run",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  (v5/*: any*/)
                                ]
                              },
                              (v5/*: any*/)
                            ]
                          },
                          (v19/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "run",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Run",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v5/*: any*/),
                          (v12/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "labelSummary",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SensorStreamLabelSummary",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "labeledFrameCount",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "viewerLabeledFrameCount",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "labeledPocketCount",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "labeledItemCount",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "labeledPalletsAll",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "LabeledPallet",
                            "plural": true,
                            "selections": [
                              (v5/*: any*/),
                              (v20/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "surfaceType",
                                "args": null,
                                "storageKey": null
                              },
                              (v21/*: any*/),
                              (v19/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "labeledItemsAll",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "LabeledItem",
                            "plural": true,
                            "selections": [
                              (v5/*: any*/),
                              (v20/*: any*/),
                              (v21/*: any*/),
                              (v19/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v13/*: any*/)
                    ]
                  },
                  (v14/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": "allSensorStreams",
            "name": "sensorStreams",
            "args": (v15/*: any*/),
            "handle": "connection",
            "key": "ListSensorStreams_allSensorStreams",
            "filters": []
          },
          (v5/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "ListSensorStreamsRefetchQuery",
    "id": null,
    "text": "query ListSensorStreamsRefetchQuery(\n  $runNameQuery: String\n  $runDateStartQuery: DateTime\n  $runDateEndQuery: DateTime\n  $labelerQuery: String\n  $allowExport: Boolean\n  $knownObjects: [KnownObject!]\n  $objectSide: [FaceSide!]\n  $objectSurface: [PalletSurface!]\n  $countAllSensorStreams: Int!\n  $after: String\n) {\n  viewer {\n    username\n    isAnonymous\n    isSupervisor\n    allSensorStreams: sensorStreams(first: $countAllSensorStreams, after: $after, runNameQuery: $runNameQuery, runDateStartQuery: $runDateStartQuery, runDateEndQuery: $runDateEndQuery, labelerQuery: $labelerQuery, knownObjects: $knownObjects, objectSide: $objectSide, objectSurface: $objectSurface, allowExport: $allowExport) {\n      pageInfo {\n        hasNextPage\n        endCursor\n      }\n      edges {\n        node {\n          id\n          ...SensorStreamListItem_sensorStream\n          numFrames\n          labelingPriority\n          createTime\n          updateTime\n          run {\n            id\n            runName\n            source\n            createTime\n            updateTime\n            knownObjects\n          }\n          __typename\n        }\n        cursor\n      }\n    }\n    id\n  }\n}\n\nfragment LabelingIssueListItem_issue on LabelingIssue {\n  id\n  description\n  category\n  status\n  reporter {\n    username\n    id\n  }\n  labeler {\n    username\n    id\n  }\n  pallets {\n    number\n    id\n  }\n  boxes {\n    number\n    id\n  }\n  sensorStream {\n    sensorName\n    run {\n      runName\n      id\n    }\n    id\n  }\n  frame {\n    indexInSensorStream\n    id\n  }\n}\n\nfragment SensorStreamListItem_sensorStream on SensorStream {\n  id\n  labelingDirections\n  lightingConditions\n  sensorName\n  numFrames\n  frameNumbers\n  labelingPriority\n  allowExport\n  issues {\n    ...LabelingIssueListItem_issue\n    status\n    id\n  }\n  run {\n    runName\n    source\n    createTime\n    updateTime\n    id\n  }\n  labelSummary {\n    labeledFrameCount\n    viewerLabeledFrameCount\n    labeledPocketCount\n    labeledItemCount\n    labeledPalletsAll {\n      id\n      objectType\n      surfaceType\n      author {\n        id\n        username\n        shortName\n      }\n      frame {\n        indexInSensorStream\n        id\n      }\n    }\n    labeledItemsAll {\n      id\n      objectType\n      author {\n        id\n        username\n        shortName\n      }\n      frame {\n        indexInSensorStream\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {
      "connection": [
        {
          "count": "countAllSensorStreams",
          "cursor": "after",
          "direction": "forward",
          "path": [
            "viewer",
            "allSensorStreams"
          ]
        }
      ]
    }
  }
};
})();
(node as any).hash = 'ee70c3de6d05fd3c96bd2f73bde78210';
export default node;
